import { PreloadedQuery } from 'react-relay';

import { pricingPageRelayQuery } from '@/__generated_contentful__/pricingPageRelayQuery.graphql';
import { PricingContentContextProviderRelay } from '@/components/wpl/pricing/src/pricing-content-context.tsx';
import { NonProfitPricingPageTemplate } from '@/templates/non-profit-pricing-page/src/non-profit-pricing-page.template';
import { PricingContent } from '@/utils/pricing-queries/get-pricing-content-gql.ts';
import { UserLocale } from '@/utils/useGeoCurrency.ts';

import { AppPricingData } from '../../../../contentful/product-catalog';

export type NonProfitPricingPageProps = {
	pricing?: AppPricingData;
	countryCode?: UserLocale;
	pricingContent?: PricingContent;
	queryRef?: PreloadedQuery<pricingPageRelayQuery>;
};

export const NonProfitPricingPage = ({
	pricing,
	countryCode,
	pricingContent,
	queryRef,
}: NonProfitPricingPageProps) => {
	return (
		<PricingContentContextProviderRelay
			productId="nonprofit"
			pricingContent={pricingContent}
			queryRef={queryRef}
		>
			<div data-testid="non-profit-pricing">
				<NonProfitPricingPageTemplate pricing={pricing} countryCode={countryCode} />
			</div>
		</PricingContentContextProviderRelay>
	);
};
